import type { Program, Topic } from 'models';
import { Modal, message } from 'ui';
import { useCreatePostMutation } from '../queries/mutations';
import { PostForm, type PostFormValues } from './post-form';

type P = {
  isOpened: boolean;
  onCancel: () => void;
  onSuccess: () => void;
  preSelectedProgramTopic?: Topic;
  program: Program;
};

const CreatePost = ({ isOpened, onCancel, onSuccess, preSelectedProgramTopic, program }: P) => {
  const { isPending, mutate } = useCreatePostMutation();

  const onSubmit = (post: PostFormValues) => {
    mutate(
      { post, programId: program.id },
      {
        onError() {
          message.error('Failed to create post.');
        },
        onSuccess() {
          onSuccess();
          message.success('Post was created.');
        },
      },
    );
  };

  return (
    <Modal isOpened={isOpened} onCancel={onCancel} title="Create Post" width="medium">
      <Modal.HugContent>
        <PostForm
          loading={isPending}
          mode="create"
          onSubmit={onSubmit}
          preSelectedProgramTopicId={preSelectedProgramTopic?.id}
          program={program}
        />
      </Modal.HugContent>
    </Modal>
  );
};

export default CreatePost;
